import { writable, get } from 'svelte/store';
import { loadSearch } from '../api/search.api';
import { updateUrlParameter } from '../../../core/helpers/url.helper';
import { windowPushHistory } from '../../../core/helpers/window.helper';
export default class SearchService {
    constructor(dataProvider) {
        this._dataProvider = dataProvider;
        this._pager = writable({ page: 1, perPage: 10 });
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        this._searchList = writable([]);
        this._total = writable(0);
        this._error = writable(false);
        this._processing = writable(false);
        this._active = writable(false);
        if (this._dataProvider.isSubmitFromUrlAllowed) {
            this.submitFromUrl();
        }
    }
    submitSearch() {
        const searchString = this._dataProvider.searchString;
        const resultUrl = this._dataProvider.resultUrl;
        this.setPage(1);
        if (searchString && this.dataProvider.arrowCounter === -1) {
            if (resultUrl) {
                window.location.href = resultUrl + '?q=' + searchString;
            }
            else {
                windowPushHistory(updateUrlParameter("q", searchString));
                this._active.set(true);
                this.loadSearchResults(searchString);
            }
        }
    }
    goToPage(page) {
        windowPushHistory(updateUrlParameter("strana", page));
        const urlSearchString = this._dataProvider.searchParameterFromUrl;
        if (urlSearchString) {
            this.setPage(page);
            this.loadSearchResults(urlSearchString);
        }
    }
    changePageSize(pageSize) {
        windowPushHistory(updateUrlParameter("pocet", pageSize));
        this.setPageSize(pageSize);
        this.goToPage(1);
    }
    submitFromUrl() {
        const urlSearchString = this._dataProvider.searchParameterFromUrl;
        const urlPage = this._dataProvider.pageParameterFromUrl;
        const urlPageSize = this._dataProvider.pageSizeParameterFromUrl;
        if (urlPageSize)
            this.setPageSize(urlPageSize);
        if (urlSearchString && urlPage) {
            this.setPage(urlPage);
            this._active.set(true);
            this.loadSearchResults(urlSearchString);
        }
    }
    loadSearchResults(searchString) {
        this._processing.set(true);
        loadSearch(searchString, this.dataProvider.apiStructureKeys, this.dataProvider.showSiteUrl, this.dataProvider.groupId, this.dataProvider.endpoint, this.pager)
            .then((response) => {
            this._searchList.set(response.results);
            this._pager.set(Object.assign(Object.assign({}, this.pager), { total: response.total }));
            this._total.set(response.total);
            this._error.set(false);
        })
            .catch(() => this._error.set(true))
            .finally(() => this._processing.set(false));
    }
    setPage(page) {
        this._pager.set(Object.assign(Object.assign({}, this.pager), { page }));
    }
    setPageSize(perPage) {
        this._pager.set(Object.assign(Object.assign({}, this.pager), { perPage }));
    }
    get dataProvider() {
        return this._dataProvider;
    }
    get searchListSubs() {
        return this._searchList;
    }
    get activeSubs() {
        return this._active;
    }
    get totalSubs() {
        return this._total;
    }
    get errorSubs() {
        return this._error;
    }
    get processingSubs() {
        return this._processing;
    }
    get pagerSubs() {
        return this._pager;
    }
    get pager() {
        return get(this._pager);
    }
}
